export interface BulkMergeWriteSummary {
    entriesBatched: number;
    entriesIndividual: number;
    batchCount: number;
    largestBatchEntries: number;
    payloadCharsTotal: number;
    payloadCharsLargestEntry: number;
    batchPayloadCapChars: number;
    writeDurationMs: number;
}

export const NO_MERGE_WRITE: BulkMergeWriteSummary = {
    entriesBatched: 0,
    entriesIndividual: 0,
    batchCount: 0,
    largestBatchEntries: 0,
    payloadCharsTotal: 0,
    payloadCharsLargestEntry: 0,
    batchPayloadCapChars: 0,
    writeDurationMs: 0,
};

export function combinedMergeWriteSummary(summaries: BulkMergeWriteSummary[]): BulkMergeWriteSummary {
    return summaries.reduce<BulkMergeWriteSummary>(
        (combined, summary) => ({
            entriesBatched: combined.entriesBatched + summary.entriesBatched,
            entriesIndividual: combined.entriesIndividual + summary.entriesIndividual,
            batchCount: combined.batchCount + summary.batchCount,
            largestBatchEntries: Math.max(combined.largestBatchEntries, summary.largestBatchEntries),
            payloadCharsTotal: combined.payloadCharsTotal + summary.payloadCharsTotal,
            payloadCharsLargestEntry: Math.max(combined.payloadCharsLargestEntry, summary.payloadCharsLargestEntry),
            batchPayloadCapChars: Math.max(combined.batchPayloadCapChars, summary.batchPayloadCapChars),
            writeDurationMs: combined.writeDurationMs + summary.writeDurationMs,
        }),
        NO_MERGE_WRITE,
    );
}
